import React from 'react';
import SemesterResultCard from './SemesterResultCard';

const Dashboard = () => {
  return (
    <div className="flex justify-center items-center h-fit shadow-lg">
      <SemesterResultCard />
    </div>
  );
};

export default Dashboard;
